import React, { useEffect, lazy, Suspense, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { jarallax } from 'jarallax';

import NavbarComponent from "./components/NavbarComponent";
import FooterComponent from "./components/FooterComponent";
import FooterBottom from "./components/FooterBottom";
import Loader from "./components/Loader"; // Loader komponenta
import AOS from 'aos';
import 'aos/dist/aos.css';
import CookieBanner from "./components/CookieBanner";
import AccessibilityWidget from "./components/AccessibilityWidget";
import { LanguageProvider } from "./context/LanguageContext";

// Lazy load stranica
const Pocetna = lazy(() => import("./pages/Pocetna"));
const Onama = lazy(() => import("./pages/Onama"));
const Kontakt = lazy(() => import("./pages/Kontakt"));
const AiStrucnjakOnline = lazy(() => import("./pages/AiStrucnjakOnline"));
const AnaliticarStrojnoUcenjeUzivo = lazy(() => import("./pages/AnaliticarStrojnoUcenjeUzivo"));
const ProgramerUzivo = lazy(() => import("./pages/ProgramerUzivo"));
const Edih = lazy(() => import("./pages/Edih"));
const BlogList = lazy(() => import("./pages/BlogList"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const UMedijima = lazy(() => import("./pages/UMedijima"));
const Prijave = lazy(() => import("./pages/Prijave"));
const Privacy = lazy(() => import("./pages/Privacy"));

function App() {
  const location = useLocation(); // Pratimo promjene URL-a
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // 1. Logika za skrolovanje (Hash links)
    const handleScroll = () => {
      const hash = window.location.hash;
      if (hash) {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          setTimeout(() => {
            element.scrollIntoView({ behavior: "smooth" });
          }, 100);
        }
      } else {
        window.scrollTo(0, 0);
      }
    };

    handleScroll();

    // 2. Inicijalizacija animacija (AOS)
    AOS.init({
      duration: 1000,
      once: true,
    });
    
    // 3. Inicijalizacija Parallax efekata (Jarallax)
    setTimeout(() => {
      jarallax(document.querySelectorAll(".jarallax"), {
        speed: 0.8,
      });
    }, 500);
  }, [location]);

  // Kada se promijeni ruta, prikaži loader
  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 750); // Simulacija učitavanja
    return () => clearTimeout(timer);
  }, [location]);

  return (
    <LanguageProvider>
      <div>
        {!loading && <NavbarComponent />}
        <Suspense fallback={<Loader />}>
          {loading ? <Loader /> : (
            <Routes>
              <Route path="/" element={<Pocetna />} />
              <Route path="/o-nama" element={<Onama />} />
              <Route path="/kontakt" element={<Kontakt />} />
              <Route path="/ai-strucnjak-online" element={<AiStrucnjakOnline />} />
              <Route path="/analiticar-strojno-ucenje-uzivo" element={<AnaliticarStrojnoUcenjeUzivo />} />
              <Route path="/ai-programer-online" element={<AnaliticarStrojnoUcenjeUzivo />} />
              <Route path="/ai-programer-uzivo" element={<ProgramerUzivo />} />
              <Route path="/edih" element={<Edih />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/u-medijima" element={<UMedijima />} />
              <Route path="/prijave" element={<Prijave />} />
              <Route path="/privatnost" element={<Privacy />} />
            </Routes>
          )}
        </Suspense>
        {!loading && <FooterComponent />}
        {!loading && <FooterBottom />}
        {!loading && <CookieBanner />}
        {!loading && <AccessibilityWidget />}
      </div>
    </LanguageProvider>
  );
}

export default App;
